module.exports = __webpack_public_path__ + "static/media/sport_feminin_2.4c65516b.jpg";